import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section(
    ({ theme }) => css`
        width: inherit;
        overflow: hidden;
        padding: 0.5rem 0;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 2rem 1.5rem 1rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: 2rem 4rem 1rem;
        }
    `,
)

export const InnerContainer = styled.div(
    ({ theme }) => css`
        margin: 0 1rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin: 0 1.5rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin: 0 auto;
        }
    `,
)

export const QuoteContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: ${theme.spacing.medium};
        padding: ${theme.spacing.medium} 0;
    `,
)

export const QuoteIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 3.5rem;
        height: 3.5rem;
    }
`

export const QuoteText = styled.blockquote(
    ({ theme }) => css`
        margin: 0;
        font-weight: 500;
        font-size: 1.25rem;
        line-height: 1.75rem;
        text-align: center;
        color: #8055c2;
        max-width: 60rem;

        &::before,
        &::after {
            content: '"';
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.large};
            line-height: 1.5;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 1.5625rem;
            line-height: 1.875rem;
        }
    `,
)
